import requester from '@/services/requester'
import env from '@/.env.js'

const BACKEND_API_V1_URL = env.endpoint_backend

export default {
    retrieve (parameters) {
        return requester.post(`${BACKEND_API_V1_URL}/usersroles`, parameters)
    },

    update (parameters) {
        return requester.put(`${BACKEND_API_V1_URL}/usersroles`, parameters)
    },

    create (parameters) {
        return requester.post(`${BACKEND_API_V1_URL}/usersroles/create`, parameters)
    },

    delete (parameters) {
        return requester.put(`${BACKEND_API_V1_URL}/usersroles/delete`, parameters)
    },

    restore (parameters) {
        return requester.put(`${BACKEND_API_V1_URL}/usersroles/restore`, parameters)
    },
}
